import { KinhPhiNhapHocService } from "../services/kinhphinhaphoc.service";

var state = {
	kinhphi: {
		id: "",
		khoaId: "",
		tienHocPhi: "",
		tienKhamSk: "",
		tienBhyt: "",
		tienTheSv: "",
		tienThueGdqp: "",
		tienLePhiNh: "",
		tienKiemTraHs: "",
	},
};

var getters = {};

var mutations = {
	getHocPhiByKhoaId(state, data) {
		state.kinhphi = data;
	},
};

var actions = {
	getHocPhiByKhoaId({ commit }, khoaId) {
		return KinhPhiNhapHocService.getHocPhiByKhoaId(khoaId)
			.then((response) => {
				if (response.status === 200) commit("getHocPhiByKhoaId", response.data);
				return response;
			})
			.catch((error) => error.message);
	},
};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
